let elementName = `nss-ship-estimate`;
if (typeof customElements.get(elementName) === `undefined`) {
  class NSSShipEstimate extends HTMLElement {
    connectedCallback() {
      this.render();
    }

    // Adds `count` deliverable days to `start`: Mondays-Saturdays count,
    // Sundays are skipped (no Sunday delivery).
    addDays(start, count) {
      const d = new Date(start);
      let left = count;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0) left--;
      }
      return d;
    }

    render() {
      let min = parseInt(this.getAttribute(`data-ship-min-days`), 10) || 5;
      let max = parseInt(this.getAttribute(`data-ship-max-days`), 10) || 7;
      const cutoff = parseInt(this.getAttribute(`data-ship-cutoff-hour`), 10);

      // Warehouse clock (store timezone) decides both "today" and the
      // cutoff, so the range is consistent for shoppers in any timezone.
      const tz = `America/New_York`;
      const ymd = new Date().toLocaleDateString(`en-CA`, { timeZone: tz });
      const [y, mo, da] = ymd.split(`-`).map(Number);
      let now = new Date(y, mo - 1, da);

      // ETD override (custom.nss_ships_from): a future date replaces "today"
      // as the counting start and the cutoff no longer applies.
      let shipsFrom = null;
      const shipsFromAttr = this.getAttribute(`data-ships-from`);
      if (shipsFromAttr && /^\d{4}-\d{2}-\d{2}$/.test(shipsFromAttr)) {
        const [fy, fm, fd] = shipsFromAttr.split(`-`).map(Number);
        const candidate = new Date(fy, fm - 1, fd);
        if (candidate > now) shipsFrom = candidate;
      }
      if (shipsFrom) {
        now = shipsFrom;
      } else if (!isNaN(cutoff)) {
        const hour = parseInt(
          new Intl.DateTimeFormat(`en-US`, { hour: `numeric`, hourCycle: `h23`, timeZone: tz }).format(new Date()),
          10
        );
        if (hour >= cutoff) {
          min += 1;
          max += 1;
        }
      }

      const from = this.addDays(now, min);
      const to = this.addDays(now, Math.max(max, min));
      const month = (d) => d.toLocaleDateString(`en-US`, { month: `long` });
      if (from.getMonth() === to.getMonth() && from.getDate() === to.getDate()) {
        this.textContent = `${month(from)} ${from.getDate()}`;
      } else if (from.getMonth() === to.getMonth()) {
        this.textContent = `${month(from)} ${from.getDate()} - ${to.getDate()}`;
      } else {
        this.textContent = `${month(from)} ${from.getDate()} - ${month(to)} ${to.getDate()}`;
      }
    }
  }

  customElements.define(elementName, NSSShipEstimate);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
